import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/supabaseClient';

const fetchUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser();

  if (error) {
    throw new Error(error.message);
  }

  if (!user) {
    return null;
  }

  return {
    id: user.id,
    fullName: user.user_metadata?.full_name || user.user_metadata?.name || 'User',
    email: user.email,
  };
};

export const useUser = () => {
  return useQuery({
    queryKey: ['user'],
    queryFn: fetchUser,
  });
};
